import { COLORS } from "common/colors";
import { format } from "path";

export const GRAPHS = {
  getColumnGraph: (
    title: string,
    xAxis: string[],
    yAxis: number[],
    xAxisTitle: string,
    yAxisTitle: string[],
    exportTitle?: string,
    height?: number,
    stacked = false,

    series = []
    // inverted = false
  ) => {
    return {
      chart: {
        type: "column",
        // inverted: inverted,
        height,
        panning: true,
        marginTop: 60,
        marginLeft: 60,
        lang: {
          decimalPoint: ".",
          thousandsSep: ",",
        },
        options3d: {
          enabled: true,
          alpha: 0,
          beta: 10,
          viewDistance: 25,
          depth: 60,
        },
      },
      credits: false,
      title: {
        align: "center",
        text: title || "",
      },
      exporting: {
        filename: exportTitle || new Date().getTime().toString(),
      },
      accessibility: {
        announceNewData: {
          enabled: true,
        },
      },
      xAxis: {
        categories: xAxis,
        title: {
          text: xAxisTitle, //"Number of Reports",
        },
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: yAxisTitle, //"Number of Reports",
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          colorByPoint: true,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: "{point.y:.1f}",
          },
          stacking: stacked ? "normal" : "",
        },
      },
      tooltip: {
        headerFormat:
          '<span style="font-size:11px;font-weight:bold;">{series.stack}</span><br>',
        pointFormat: "Value: <b>{point.y:.1f}</b><br/>",
      },

      series: stacked
        ? series
        : [
            {
              name: "Category",
              data: yAxis,
            },
          ],
    };
  },

  getPieGraph: (
    title: string,
    series: any[],
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "pie",
        height,
        borderRadius: 20,

        options3d: {
          enabled: true,
          alpha: 45,
          beta: 0,
        },
      },
      credits: false,
      title: {
        text: title,
      },
      exporting: {
        filename: exportTitle,
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          innerSize: 100,
          depth: 45,
        },
      },
      series,
    };
  },

  getStackedBar: (
    title: string,
    xAxis: string[],
    yAxis: number[],
    series: any[],
    xAxisTitle: string,
    yAxisTitle: string,
    exportTitle?: string,

    height?: number
  ) => {
    return {
      chart: {
        type: "bar",
        height,
      },
      title: title,
      xAxis: {
        categories: xAxis,
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        reversed: true,
      },
      plotOptions: {
        series: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
          },
        },
      },
      series,
    };
  },

  getSolidGauge: (
    title: string,
    series: any[],
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "solidgauge",
        height,
      },
      title: title,
      credits: {
        enabled: false,
      },
      pane: {
        center: ["50%", "85%"],
        size: "140%",
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor: "#EEE",
          innerRadius: "60%",
          outerRadius: "100%",
          shape: "arc",
        },
      },
      exporting: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: "Pending Action",
        },
        stops: [
          [0.0, "#55BF3B"], // green
          [0.0, "#DDDF0D"], // yellow
          [0.0, "#DF5353"], // red
        ],
        lineWidth: 0,
        tickWidth: 0,
        minorTickInterval: null,
        tickAmount: 2,
        title2: {
          y: -70,
        },
        labels: {
          y: 16,
        },
      },

      plotOptions: {
        solidgauge: {
          dataLabels: {
            y: 5,
            borderWidth: 0,
            useHTML: true,
          },
        },
      },

      series,
    };
  },

  getBarGraph: (
    title: string,
    xAxis: string[],
    yAxis: number[],
    xAxisTitle: string,
    yAxisTitle: string,
    colors: string[],
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "bar",
        height,
        colorBypoint: true,
      },
      title: {
        text: title,
      },
      xAxis: {
        categories: xAxis,
        title: {
          text: xAxisTitle,
        },
        gridLineWidth: 1,
        lineWidth: 0,
      },
      yAxis: {
        min: 0,
        title: {
          text: yAxisTitle,
          align: "high",
        },
        labels: {
          overflow: "justify",
        },
        gridLineWidth: 0,
      },

      // tooltip: {
      //     valueSuffix: ' millions'
      // },
      plotOptions: {
        bar: {
          borderRadius: "1.5%",
          colorByPoint: true,
          // colors: colors,
          dataLabels: {
            enabled: true,
          },
          groupPadding: 0.35,
        },
      },
      exporting: {
        filename: exportTitle || new Date().getTime().toString(),
      },
      legend: false,
      credits: {
        enabled: false,
      },
      series: [
        {
          data: yAxis,
        },
      ],
    };
  },

  getLineGraph: (
    title: string,
    xAxis: string[],
    series: any[],
    xAxisTitle: string,
    yAxisTitle: string,
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "line",
        height,
        options3d: {
          enabled: true,
          alpha: 0,
          beta: 10,
          viewDistance: 25,
          depth: 60,
        },
      },
      title: {
        text: title,
      },
      xAxis: {
        categories: xAxis,
        title: {
          text: xAxisTitle,
        },
      },
      yAxis: {
        title: {
          text: yAxisTitle,
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
          },
          enableMouseTracking: false,
        },
      },
      // [
      //   {
      //     name: "Category",
      //     data: yAxis, (the values for y axis) ex:[16.0, 18.2, 23.1, 27.9, 32.2]
      //     color: COLORS.PRIMARY,
      //   },
      // ]
      series,
    };
  },

  getAreaGraph: (
    title: string,
    xAxis: string[],
    series: any[],
    xAxisTitle: string,
    yAxisTitle: string,
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "area",
      },
      accessibility: {
        description:
          "Image description: An area chart compares the nuclear stockpiles of the USA and the USSR/Russia between 1945 and 2017. The number of nuclear weapons is plotted on the Y-axis and the years on the X-axis. The chart is interactive, and the year-on-year stockpile levels can be traced for each country. The US has a stockpile of 6 nuclear weapons at the dawn of the nuclear age in 1945. This number has gradually increased to 369 by 1950 when the USSR enters the arms race with 6 weapons. At this point, the US starts to rapidly build its stockpile culminating in 32,040 warheads by 1966 compared to the USSR’s 7,089. From this peak in 1966, the US stockpile gradually decreases as the USSR’s stockpile expands. By 1978 the USSR has closed the nuclear gap at 25,393. The USSR stockpile continues to grow until it reaches a peak of 45,000 in 1986 compared to the US arsenal of 24,401. From 1986, the nuclear stockpiles of both countries start to fall. By 2000, the numbers have fallen to 10,577 and 21,000 for the US and Russia, respectively. The decreases continue until 2017 at which point the US holds 4,018 weapons compared to Russia’s 4,500.",
      },
      title: {
        text: "US and USSR nuclear stockpiles",
      },
      subtitle: {
        text:
          'Source: <a href="https://fas.org/issues/nuclear-weapons/status-world-nuclear-forces/" ' +
          'target="_blank">FAS</a>',
      },
      xAxis: {
        allowDecimals: false,
        accessibility: {
          rangeDescription: "Range: 1940 to 2017.",
        },
      },
      yAxis: {
        title: {
          text: "Nuclear weapon states",
        },
      },
      tooltip: {
        pointFormat:
          "{series.name} had stockpiled <b>{point.y:,.0f}</b><br/>warheads in {point.x}",
      },
      plotOptions: {
        area: {
          pointStart: 1940,
          marker: {
            enabled: false,
            symbol: "circle",
            radius: 2,
            states: {
              hover: {
                enabled: true,
              },
            },
          },
        },
      },
      // [
      //   {
      //     name: "Category",
      //     data: yAxis, (the values for y axis) ex:[16.0, 18.2, 23.1, 27.9, 32.2]
      //     color: COLORS.PRIMARY,
      //   },
      // ]
      series,
    };
  },

  getColumnRangeGraph: (
    title: string,
    xAxis: string[],
    series: any[],
    xAxisTitle: string,
    yAxisTitle: string,
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "columnrange",
        inverted: true,
      },
      title: {
        text: title,
      },
      credits: false,
      xAxis: {
        categories: xAxis,
        title: {
          text: xAxisTitle,
        },
      },
      yAxis: {
        title: {
          text: yAxisTitle,
        },
      },
      tooltip: {
        valueSuffix: "°C",
      },
      plotOptions: {
        columnrange: {
          borderRadius: "50%",
          dataLabels: {
            enabled: true,
            format: "{y}°C",
          },
        },
      },

      legend: {
        enabled: false,
      },
      series,
    };
  },
};
